import { useMutation, useQueryClient } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import { AddBankDetailsForm, UpdateBankDetailsForm } from "../schemas";
import { isAxiosError } from "axios";
import { bankDetailsQueryKeys } from "../query-keys";

type BankDetailsProfesionnalProps = AddBankDetailsForm & {
  structureId?: string;
  organiserId?: string;
};
type BankDetailsProps = AddBankDetailsForm & BankDetailsProfesionnalProps;

const addBankDetails = async (data: BankDetailsProps) => {
  const { data: response } = await privateAxios.post(`/bank-details`, data);
  return response;
};

export const useAddBankDetailsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: addBankDetails,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [bankDetailsQueryKeys.all] });
    },
    onError: (error) => {
      if (isAxiosError(error)) {
        throw {
          ...error,
          message: error.response?.data.message,
        };
      }
    },
  });
};

const deleteBankDetails = async (id: string) => {
  const { data } = await privateAxios.delete(`/bank-details/${id}`);
  return data;
};

const updateBankDetails = async (id: string, data: UpdateBankDetailsForm) => {
  const { data: response } = await privateAxios.patch(
    `/bank-details/${id}`,
    data
  );
  return response;
};

export const useUpdateBankDetailsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateBankDetailsForm }) =>
      updateBankDetails(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [bankDetailsQueryKeys.all] });
    },
    onError: (error) => {
      if (isAxiosError(error)) {
        throw {
          ...error,
          message: error.response?.data.message,
        };
      }
    },
  });
};

export const useDeleteBankDetailsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteBankDetails,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [bankDetailsQueryKeys.all] });
    },
    onError: (error) => {
      if (isAxiosError(error)) {
        throw {
          ...error,
          message: error.response?.data.message,
        };
      }
    },
  });
};
